export const EnumTranslation = {
    DeliveryOrderStatus: 'deliveryorderstatus'
};